<template>
	<div>
		<el-dialog title="协议单打印" :visible.sync="isShowModal" :close-on-click-modal="false" width="900px"
			@close="closeDialog">
			<div style="text-align: right; position: absolute; top:20px; right: 100px;">
				<el-button v-print="'#printMe'" icon="el-icon-printer" type="primary">打印</el-button>
			</div>
			<div style="width: 800px; min-height: 800px; border: 1px solid #ccc; margin: 0 auto;">
				<div id="printMe"
					style=" width: 650px; margin: 0 auto; height:1050px; overflow:  hidden; " v-html="printHtml">
					


				</div>

			</div>





		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			stuid: 0
		},
		data() {
			return {
				isShowModal: true,
				stuinfo: {
					stu_name: "",
					stu_code: "",
					major_name: "",
					xuezhi: "",
				},
				fee: {
					xuefei: 0,
					total: 0,
					other: []
				},
				teacherInfo: {
					username: ""
				},
				date: "",
				printHtml:""
			}
		},
		mounted() {
			let d = new Date();

			this.date = d.getFullYear() + "年" + (d.getMonth() + 1) + "月" + d.getDate() + "日"
			this.teacherInfo = JSON.parse(sessionStorage.getItem("userinfo"))
			this.getInfo()
		},
		methods: {
			getTemp(){
				
				this.$http.post("/api/t_sch_printer_list",{ktype:"ptype",keyword:"xieyi"}).then(res=>{
					let printHtml = res.data[0].pjson;
					printHtml = printHtml.replace(/\${学生编号}/g,this.stuinfo.stu_code)
					printHtml = printHtml.replace(/\${学生姓名}/g,this.stuinfo.stu_name)
					printHtml = printHtml.replace(/\${院系}/g,this.stuinfo.yuanxi_name)
					printHtml = printHtml.replace(/\${专业}/g,this.stuinfo.major_name)
					printHtml = printHtml.replace(/\${学制}/g,this.stuinfo.xuezhi)
					
					printHtml = printHtml.replace(/\${今日日期}/g,this.date)
					
					printHtml = printHtml.replace(/\${考试号}/g,this.stuinfo.exam_num)
					printHtml = printHtml.replace(/\${建档号}/g,this.stuinfo.archive)
					printHtml = printHtml.replace(/\${学生性别}/g,this.stuinfo.gender==1?'男':'女')
					printHtml = printHtml.replace(/\${准考证号}/g,this.stuinfo.exam_num)
					printHtml = printHtml.replace(/\${分数}/g,this.stuinfo.exam_score)
					printHtml = printHtml.replace(/\${学生电话}/g,this.stuinfo.phone)
					printHtml = printHtml.replace(/\${学生电话2}/g,this.stuinfo.phone2)
					printHtml = printHtml.replace(/\${办理人}/g,this.teacherInfo.username)
					printHtml = printHtml.replace(/\${报道须知号}/g,this.stuinfo.fee_idx)
					printHtml = printHtml.replace(/\${缴费序号}/g,this.stuinfo.fee_idx)
					printHtml = printHtml.replace(/line-height: normal/g,'line-height: 14px')
					
					//费用
					let fee = "";
					if(this.fee.xuefei){
						fee+="学费：<span style='padding:0 10px;text-decoration: underline;'>"+this.fee.xuefei+"元</span>"
					}
					
					if(this.fee.other){
						for(let f of this.fee.other){
							fee+=f.fee_name+"：<span style='padding:0 5px;text-decoration: underline;'>"+f.stu_fee+"元</span>，"
						}
						
					}
					
					if(this.fee.total){
						fee+="总计：<span style='padding:0 10px;text-decoration: underline;'>"+this.fee.total+"元</span>"
					}
					printHtml = printHtml.replace(/\${费用详细}/g,fee)
					printHtml = printHtml.replace(/\${费用合计数字}/g,this.fee.total)
					
					printHtml = printHtml.replace(/\${费用合计大写}/g,this.digitUppercase(this.fee.total))
					
					this.printHtml = printHtml
					this.$http.post("/api/app_platform_info").then(app=>{
						
						this.printHtml = this.printHtml.replace(/\${学校名称}/g,app.data.platform)
					})
				})
				
			
			},
			getInfo() {
				this.$http.post("/api/sch_student_one", {
					stu_id: this.stuid
				}).then(res => {
					this.stuinfo = res.data
					//计算缴费信息
					let stufee = [];
					if (res.data.fee.stu) {
						stufee = JSON.parse(res.data.fee.stu.remark)
						this.fee.total = res.data.fee.stu.total_money;
					}
					for (let item of res.data.fee.data) {
						for (let sfee of stufee) {
							if (item.id == sfee.id) {
								item.stu_fee = sfee.stu_fee;
								if (item.fee_name.indexOf("学费") > 0 && item.stu_fee > 0) {
									this.fee.xuefei = item.stu_fee
								}
								break
							}
						}
					}

					let feelist = [];
					for (let item of res.data.fee.data) {
						if (item.stu_fee) {
							if (item.fee_name.indexOf("学费") > 0) {

							} else {
								if (item.fee_name.indexOf("材料费") >= 0) {
									item.fee_name = '材料费'
								}
								feelist.push(item)
							}
						}
					}

					this.fee.other = feelist
					this.getTemp()


				})
			},
			closeDialog() {
				this.$parent.closePrint()
			}
		}
	}
</script>

<style scoped="scoped">
	.uline {
		text-decoration: underline;
	}
	
</style>
<style>
	#printMe p{  }
</style>
